var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dashboard-card',{attrs:{"title":_vm.title,"popover":_vm.popover}},[_c('div',[_c('apexchart',{attrs:{"type":_vm.chartOptions.chart.type,"height":_vm.chartOptions.chart.height,"options":_vm.chart.options,"series":_vm.chart.data}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }